<template>
    <tq-loader-container :p_show-loader_b="server_currentUserData_c === undefined" :p_tq-loader_b="true" class="TQ_center" :data-hook="DataHooks_o.comp_profile">
        <div v-if="server_currentUserData_c !== undefined" class="TQ_maxWidth_700px TQ_center">

            <!-- tabs -->
            <div class="TQ_align_initial TQ_margin_bottom_2px" v-if="!server_currentUserData_c.ud_m_guestUser_b()">
                <div v-for="(title_blc_s, index_n) in [ass_strings.twoWords_basicInfo, ass_strings.twoWords_billingSetting]"
                     :key="index_n"
                     @click="selectedTabIndex_n = index_n"
                     :class="[selectedTabIndex_n === index_n ? 'TQ_bg_purple' : 'TQ_bg_hover_goldLite', index_n%2 === 1 && 'TQ_margin_0_2px'] "
                     class="TQ_inline TQ_padding_8px TQ_bg_white TQ_text_20px TQ_clickable TQ_borderRadius TQ_text_capitalize" >
                    {{title_blc_s[store_system_langCode_ve.val]}}
                </div>
            </div>

            <!-- guest title -->
            <div v-else class="TQ_bg_purple_dark TQ_padding_8px TQ_text_24px TQ_borderRadius_top TQ_text_capitalize">
                {{ass_strings.oneWord_guest[store_system_langCode_ve.val]}}
            </div>

            <!-- personal info -->
            <div class="TQ_padding_8px TQ_bg_white TQ_borderRadius" v-if="selectedTabIndex_n === 0 && new_server_uds_moreInfo_c">

                <!-- avatar -->
                <div class="TQ_margin_top_16px">

                    <div>
                        <tq-avatar
                            @click.native="showPopup_avatarGenerator_vb.val=true"
                            :p_ud_avatar_c="new_server_currentUserData_c.ud_avatar_c"
                            class="TQ_clickable TQ_width_125px TQ_bg_circle TQ_box_shadow2 TQ_padding_4px TQ_inlineGrid TQ_height_125px TQ_bg_hover_goldLite"/>

                    </div>

                    <div class="TQ_text_bold TQ_text_20px ">
                        {{ass_strings.oneWord_level[store_system_langCode_ve.val]}} {{ server_currentUserData_c.ud_m_level_s() }}
                    </div>

                    <!-- total points-->
                    <div class="">
                        {{server_currentUserData_c.ud_levelTotalPoints_n}} {{ ass_strings.oneWord_points[store_system_langCode_ve.val] }}
                    </div>
                </div>

                <!-- full name -->
                <div class="TQ_margin_8px">
                    <div class="TQ_text_20px  TQ_font_SecularOne TQ_textAlign_initial "> {{ass_strings.twoWords_fullName[store_system_langCode_ve.val]}} </div>
                    <tq-textarea
                        pb_uid_s="fullName"
                        pb_textarea-class_s="TQ_center TQ_text_20px TQ_padding_8px"
                        :pb_init-text_s="new_server_currentUserData_c.ud_name_s"
                        :pb_max-length_n="20"
                        :pb_placeholder_s="ass_strings.oneWord_name[store_system_langCode_ve.val]"
                        :pb_rows_n="1"
                        :pe_change-text_s="(text_s) => {new_server_currentUserData_c.ud_name_s = text_s}"
                    />
                </div>

                <!-- email -->
                <div class="TQ_margin_8px TQ_margin_bottom_16px" v-if="new_server_currentUserData_c.ud_email_s" >
                    <div class="TQ_text_20px  TQ_font_SecularOne TQ_textAlign_initial"> {{ass_strings.oneWord_email[store_system_langCode_ve.val]}} </div>

                    <div class="TQ_center TQ_text_20px TQ_padding_8px TQ_border" :data-hook="DataHooks_o.comp_profile_email">
                        {{new_server_currentUserData_c.ud_email_s}}
                    </div>
                </div>

                <!-- Phone -->
                <div class="TQ_margin_8px" v-if="server_uds_moreInfo_c !== undefined && !server_currentUserData_c.ud_m_guestUser_b()">

                    <div class="TQ_text_20px  TQ_font_SecularOne TQ_textAlign_initial"> {{ass_strings.twoWords_phoneNumber[store_system_langCode_ve.val]}} </div>
                    <tq-textarea
                        :key="refreshPhoneTextarea_n"
                        pb_uid_s="phone"
                        pb_textarea-class_s="TQ_center TQ_text_20px TQ_padding_8px TQ_direction_ltr"
                        :pb_init-text_s="new_server_uds_moreInfo_c.udsmi_phone_s"
                        :pb_max-length_n="12"
                        :pb_placeholder_s="ass_strings.twoWords_phoneNumber[store_system_langCode_ve.val]"
                        :pb_rows_n="1"
                        :pe_change-text_s="(text_s) => {new_server_uds_moreInfo_c.udsmi_phone_s = text_s}"
                    />

                </div>

                <!-- lang codes -->
                <div class="TQ_textAlign_initial">

                    <!-- emails lang -->
                    <div class="TQ_margin_8px ">

                        <!-- title -->
                        <div class="TQ_text_20px TQ_font_SecularOne TQ_text_capitalize">
                            {{ass_strings.twoWords_emailsLanguage[store_system_langCode_ve.val]}}
                        </div>

                        <!-- lang code-->
                        <tq-dropdown :show-caret-down="false" :ps_only-mobile-mode_b="true" max-height="420px" class="TQ_center TQ_width_100p">

                            <div slot="select" class="TQ_border TQ_borderRadius  TQ_padding_16px  TQ_clickable TQ_bg_hover_goldLite TQ_borderBox TQ_width_100p">
                                <div class="TQ_text_20px"> {{format_langCode_fs(new_server_currentUserData_c.ud_langCode_e)}} </div>
                                <tq-image :pb_src_r="helper_getLangFlagWithLangCode_fr(new_server_currentUserData_c.ud_langCode_e)" class="TQ_img TQ_width_44px"/>
                            </div>

                            <div  slot="options" v-for="langCode_e in enum_langCodes" :key="langCode_e">
                                <div class="TQ_border_bottom TQ_center TQ_padding_8px TQ_clickable TQ_bg_hover_goldLite" @click="new_server_currentUserData_c.ud_langCode_e = langCode_e">
                                    <div class="TQ_text_16px"> {{format_langCode_fs(langCode_e)}} </div>
                                    <tq-image :pb_src_r="helper_getLangFlagWithLangCode_fr(langCode_e)" class="TQ_img TQ_width_32px"/>
                                </div>
                            </div >
                        </tq-dropdown>
                    </div>
                </div>

                <!-- about me -->
                <div class="TQ_margin_8px" v-if="server_uds_moreInfo_c !== undefined && !server_currentUserData_c.ud_m_guestUser_b()" >
                    <div class="TQ_text_20px  TQ_font_SecularOne TQ_textAlign_initial"> {{ass_strings.threeWords_tellAboutYourself[store_system_langCode_ve.val]}} </div>

                    <!-- langCodes -->
                    <div class="TQ_textAlign_initial ">
                        <div class="TQ_inline TQ_verticalAlignMiddle">
                            <div v-for="langCode_e in new_server_uds_moreInfo_c.udsmi_langArr_ae" :key="langCode_e"
                                class="TQ_text_bold TQ_clickable TQ_inline TQ_padding_8px TQ_box_shadow" :class="selectedMoreInfoLangCode_e===langCode_e ? 'TQ_bg_purple' : 'TQ_bg_gray3'"
                                @click="selectedMoreInfoLangCode_e=langCode_e">
                                {{format_langCode_fs(langCode_e)}}
                            </div>
                        </div>

                        <!-- add new lang code-->
                        <tq-dropdown :ps_only-mobile-mode_b="true" :show-caret-down="false" v-if="co_availableMoreInfoLangCode_ae.length > 0">

                            <tq-image slot="select" class="TQ_inline TQ_padding_8px TQ_width_16px TQ_bg_green TQ_verticalAlignMiddle TQ_margin_0_2px" :pb_src_r="ass_img_add_w"/>


                            <div slot="options" v-for="langCode_e in co_availableMoreInfoLangCode_ae" :key="langCode_e"
                                @click="new_server_uds_moreInfo_c.udsmi_langArr_ae.push(langCode_e)"
                                class="TQ_border_bottom TQ_padding_8px">
                                {{ format_langCode_fs(langCode_e) }}
                            </div>
                        </tq-dropdown>
                    </div>

                    <tq-textarea
                        v-if="selectedMoreInfoLangCode_e"
                        :style="{direction : helper_getDirectionByLangCode_fe(selectedMoreInfoLangCode_e)}"
                        :pb_uid_s="'about' + selectedMoreInfoLangCode_e"
                        pb_textarea-class_s="TQ_text_16px"
                        :pb_init-text_s="new_server_uds_moreInfo_c.udsmi_about_blc_s[selectedMoreInfoLangCode_e]"
                        :pb_max-length_n="450"
                        :pb_placeholder_s="ass_strings.threeWords_tellAboutYourself[selectedMoreInfoLangCode_e]"
                        :pb_rows_n="5"
                        :pf_autoresize_b="true"
                        :pe_change-text_s="(text_s) => {$set(new_server_uds_moreInfo_c.udsmi_about_blc_s, selectedMoreInfoLangCode_e, text_s)}"
                    />

               
                </div>

                <!-- btns -->
                <div v-if="server_currentUserData_c.ud_m_guestUser_b()" class="TQ_padding_8px ">

                    <tq-info class="TQ_inline TQ_verticalAlignMiddle TQ_padding_4px TQ_margin_bottom_-4px"
                             :p_lang-code_e="store_system_langCode_ve.val"
                             p_width_n="24px"
                             p_text_s="שלום אורח, על מנת שנוכל לזהות אותך בהמשך הדרך, מומלץ להתחבר למערכת"/>

                    <div v-if="pe_showLogin_f" class="TQ_inline TQ_bg_gold TQ_borderRadius TQ_padding_4px TQ_box_shadow TQ_clickable TQ_width_150px" @click="pe_showLogin_f">

                        <div class="TQ_inline TQ_verticalAlignMiddle TQ_padding_4px TQ_text_20px">
                            {{ass_strings.oneWord_login2[store_system_langCode_ve.val]}}
                        </div>
                    </div>

                    <div class="TQ_inline TQ_padding_0px_16px">

                    </div>

                </div>
 
                <div v-else class="TQ_margin_top_8px TQ_margin_bottom_8px">

                    <!-- logout btn -->
                    <tq-btn-approve
                        class="TQ_inline TQ_margin_8px"
                        :system-lang-code="store_system_langCode_ve.val"
                        :popup-text="ass_strings.question_logout"
                        :data-hook="DataHooks_o.comp_profile_logout"
                        :approve-cb="m_logout_f">
                        <div class="TQ_text_20px TQ_bg_red  TQ_text_capitalize TQ_padding_8px TQ_box_shadow TQ_borderRadius ">
                            <img :src="ass_img_exit_w" class="TQ_width_24px TQ_verticalAlignMiddle"/>
                            <div class="TQ_padding_4px TQ_inline TQ_verticalAlignMiddle"></div>
                            <div class="TQ_verticalAlignMiddle TQ_inline"> {{ass_strings.oneWord_logout[store_system_langCode_ve.val]}} </div>
                        </div>
                    </tq-btn-approve>

                    <!-- save btn -->
                    <tq-loader-button :show-loader="updateBtn_loader_b"
                                      v-if="co_uds_moreInfo_haveChanges_b || co_userData_haveChanges_b"
                                      @click.native="m_saveChanges_f"
                                      class="TQ_text_20px TQ_bg_green TQ_text_capitalize TQ_padding_8px TQ_box_shadow TQ_inline TQ_margin_8px TQ_borderRadius">

                        <img :src="ass_img_save_w" class="TQ_width_24px TQ_verticalAlignMiddle"/>
                        <div class="TQ_padding_4px TQ_inline TQ_verticalAlignMiddle"></div>
                        <div class="TQ_verticalAlignMiddle TQ_inline">
                            {{ass_strings.oneWord_save[store_system_langCode_ve.val]}}
                        </div>
                    </tq-loader-button>

                </div>

                
            </div>

            

            <!-- payment info -->
            <div class="TQ_padding_8px TQ_bg_white TQ_borderRadius" v-if="selectedTabIndex_n === 1">


                <!-- 2) payment  -->
                <tqu-creator-manage-payment></tqu-creator-manage-payment>

                <!-- credit cards -->
                <div class="TQ_margin_8px TQ_margin_top_16px">
                    <!-- title -->
                    <div class="TQ_text_20px TQ_font_SecularOne TQ_text_capitalize">
                        {{ ass_strings.twoWords_creditCards[store_system_langCode_ve.val] }}
                    </div>

                    <!-- credit card -->
                    <tq-credit-cards-list :p_show-drop-down_b="true"
                                          :p_uds_credit-cards_by-id_c="server_uds_creditCards_byId_c"
                                          :p_current-user-data_c="server_currentUserData_c"/>
                </div>
                <hr>

                <!-- save btn -->
                <tq-loader-button :show-loader="updateBtn_loader_b"
                                  v-if="co_uds_creatorPaymentInfo_haveChanges_b"
                                  @click.native="m_saveCreatorPaymentInfo_f"
                                  class="TQ_text_20px TQ_bg_green TQ_text_capitalize TQ_padding_8px TQ_box_shadow TQ_inline TQ_margin_8px TQ_borderRadius">

                    <img :src="ass_img_save_w" class="TQ_width_24px TQ_verticalAlignMiddle"/>
                    <div class="TQ_padding_4px TQ_inline TQ_verticalAlignMiddle"></div>
                    <div class="TQ_verticalAlignMiddle TQ_inline">
                        {{ass_strings.oneWord_save[store_system_langCode_ve.val]}}
                    </div>
                </tq-loader-button>
            </div>

            <!-- popup - generate avatar popup-->
            <tq-popup :show="showPopup_avatarGenerator_vb" v-if="server_currentUserData_c" max-width="750px" padding="0" :show-close-btn="true" class="TQ_center">
                <div class="TQ_text_24px TQ_bg_purple_dark TQ_padding_12px TQ_border_bottom TQ_text_capitalize ">
                    {{ass_strings.threeWords_chooseYourAvatar[store_system_langCode_ve.val]}}
                </div>

                <!-- Pure choose avatar-->
                <fcpc-avatar-generator class="TQ_margin_0_4px"
                                       :pp_get-file_vf="getFile_vf"
                                       :p_ud_avatar_c="new_server_currentUserData_c.ud_avatar_c" :p_system_lang-code_e="store_system_langCode_ve.val"/>

                <!-- btns -->
                <div class="TQ_grid_col_Auto1frAuto TQ_padding_8px TQ_border_top " >
                    <div @click="showPopup_avatarGenerator_vb.val=false"
                         class="TQ_inline TQ_bg_red TQ_padding_8px TQ_box_shadow TQ_borderRadius TQ_width_72px TQ_clickable">
                        {{ass_strings.oneWord_cancel[store_system_langCode_ve.val]}}
                    </div>
                    <div></div>
                    <div @click="m_avatarPopup_clickTheApproveBtn_f"
                         class="TQ_inline TQ_bg_purple_dark TQ_padding_8px TQ_box_shadow TQ_borderRadius TQ_width_72px TQ_clickable">
                        {{ass_strings.oneWord_approve[store_system_langCode_ve.val]}}
                    </div>
                </div>
            </tq-popup>


        </div>
    </tq-loader-container>
</template>

<script>

import {store_getStateValue_vo, store_var} from "@/store";
import {
    server_getPaymentLandingPage_token_f,
    serverPre_subUserData_creatorPaymentInfo_update_f,
    serverPre_subUserData_creditCards_delete_f,
    serverPre_subUserData_creditCards_cl_set_f,
    serverPre_subUserData_moreInfo_get_f,
    serverPre_subUserData_moreInfo_update_f,
    serverPre_subUserData_creditCards_cl_remove_f,
    serverPre_subUserData_creditCards_update_f,
    serverPre_subUserData_creatorPaymentInfo_get_f,
    serverPre_subUserData_subscriptionPlanInfo_get_f, serverPre_subUserData_subscriptionPlanInfo_update_f,
} from "@/scripts/Server/S_ServerPre";
import {route_moveToRoute, route_switchLangCode_es} from "@/router";
    import {ass_strings} from "../../../functions/src/shareCode/Share_Ass_Dictionary";
    import TqBtnApprove from "../basic2/TqBtnApprove";
    import TqTextareaAutosize from "../basic/TqTextareaAutosize";
    import TqWysiwygEditor from "../complex/TqWysiwygEditor";
import {
    enum_langCodes,
    enum_banks_n,
    enum_eventsListenersNames,
    enum_iframeMsg,
} from "../../../functions/src/shareCode/Share_S_Enum";
import {
    ass_img_add_w, ass_img_edit_b,
    ass_img_edit_w,
    ass_img_exit_w, ass_img_info_b,
    ass_img_save_w,
    ass_img_user_b,
    ass_svg_maze_circular_c,
    ass_svg_maze_circular_g,
    ass_svg_maze_heart_c,
    ass_svg_maze_heart_g,
    ass_svg_maze_hexagonal_c,
    ass_svg_maze_hexagonal_g,
    ass_svg_maze_octagonal_c,
    ass_svg_maze_octagonal_g,
    ass_svg_maze_oval_c,
    ass_svg_maze_oval_g,
    ass_svg_maze_rectangular_c,
    ass_svg_maze_rectangular_g,
    ass_svg_maze_rhombus_c,
    ass_svg_maze_rhombus_g,
    ass_svg_maze_square_c,
    ass_svg_maze_square_g,
    ass_svg_maze_star_c,
    ass_svg_maze_star_g,
    ass_svg_maze_triangular_ca,
    ass_svg_maze_triangular_g
} from "@/assets/scripts/Ass_Files";
    import TqTextarea from "../basic/TqTextarea";
import {
    FB_UserDataSub_CreatorPaymentInfo,
    FB_UserDataSub_MoreInfo, FB_UserDataSub_CreditCard
} from "../../../functions/src/shareCode/Share_S_Classes";
    import {obj_equals_fb, obj_deepCopy_f} from "../../../functions/src/shareCode/Share_S_Obj";
    import TqLoaderButton from "../basic2/TqLoaderButton";
    import TqPopup from "../basic/TqPopup";
    import TqSelectImage from "../mediaComponenets/TqSelectImage";
    import TqImage from "../basic/TqImage";
    import {FB_UserData} from "../../../functions/src/shareCode/Share_S_Classes";
    import {enum_moveToOptions} from "../../../functions/src/shareCode/Share_S_Enum";
import {
    serverAuth_currentUserData_get_vl_fp,
    serverAuth_currentUserData_remove_vl_f,
    serverAuth_currentUserData_update_f,
} from "@/scripts/Server/S_ServerAuth";
    import {webAppManager_logout_f} from "@/scripts/S_WebAppMediator";
import {helper_getDirectionByLangCode_fe, helper_getLangFlagWithLangCode_fr} from "@/scripts/S_Helper";
import {
    format_langCode_fs,
    format_bankNumber_s,
    format_date_YYYY_MM_DD_fs,
     format_cost_s
} from "../../../functions/src/shareCode/Share_S_Format";
    import TqDropdown from "../basic/TqDropdown";
    import TqCopy from "../basic2/TqCopy";
    import TqAvatar from "@/components/complex/TqAvatar";
    import FcpcAvatarGenerator from "@/components/complex/TqAvatarGenerator";
    import TqLoaderContainer from "@/components/basic/TqLoaderContainer";
    import TqTabs from "@/components/basic/TqTabs";
    import TqOnTopContainer from "@/components/basic/TqOnTopContainer";
import {eventListener_addEventListenerToObj, eventListener_removeEventListenerToObj} from "@/scripts/S_EventListeners";
import {notification_notify2} from "@/scripts/S_Notification";
import FcucLogin from "@/components/complex/TqLogin";
import TqInfo from "@/components/basic2/TqInfo";
import TqLink from "@/components/basic/TqLink";
import TqCheckbox from "@/components/basic/TqCheckbox";
import V_Pricing from "@/components/basic/TqPricing";
import TqPricing from "../basic/TqPricing";
import TqCreditCardsList from "@/components/unpure/TqCreditCardsList";
import TquCreatorManagePayment from './TquCreatorManagePayment.vue';
import { DataHooks_o } from "../../scripts/S_DataHooks";

    export default {
        name: "fcucProfile",
        components:{
            TqCreditCardsList,
            TqPricing,
            V_Pricing,
            TqCheckbox,
            TqLink,
            TqInfo,
            FcucLogin,
            TqOnTopContainer,
            TqTabs,
            TqLoaderContainer,
            FcpcAvatarGenerator,
            TqAvatar,
            TqCopy,
            TqDropdown,
            TqImage,
            TqSelectImage,
            TqPopup,
            TqLoaderButton,
            TqTextarea,
            TqWysiwygEditor,
            TqTextareaAutosize,
            TqBtnApprove,
            TquCreatorManagePayment,
        },
        props:{
            pe_showLogin_f:{
                type: Function
            }
        },
        data(){
            return {

                selectedTabIndex_n      : 1,
                creditCardUrl_s         : null,
                selectedMoreInfoLangCode_e         : null,

                updateBtn_loader_b      : false,
                refreshPhoneTextarea_n  : 0,
                showPopup_avatarGenerator_vb  : {val : false},
                showPricingPlans_vb  : {val : false},
                getFile_vf                  : {val : () => {}},

                creditCard_o : {
                    showPopup_vb : {val : false},
                    selected_c : null,
                    btnLoader_b : false,
                },
                addNewCard_o : {
                    showPopup_vb : {val : false},
                    approveJ5_b : false
                },

                icreditUrl_s  : null,

                // store
                store_system_langCode_ve       : store_getStateValue_vo(store_var.system_langCode),
                store_system_currency_ve       : store_getStateValue_vo(store_var.system_currency),
                store_system_windowSizeType_ve : store_getStateValue_vo(store_var.system_windowSizeType_e),

                // server
                server_currentUserData_c                : undefined,
                new_server_currentUserData_c            : undefined,
                server_uds_creatorPaymentInfo_c         : undefined,
                new_server_uds_creatorPaymentInfo_c     : undefined,
                server_uds_moreInfo_c                   : undefined,
                server_uds_subscriptionPlanInfo_c                : undefined,
                new_server_uds_moreInfo_c               : undefined,
                server_uds_creditCards_byId_c           : {},

                // imports
                ass_strings                 : ass_strings,
                ass_img_exit_w              : ass_img_exit_w,
                ass_img_save_w              : ass_img_save_w,
                ass_img_user_b              : ass_img_user_b,
                ass_img_edit_w              : ass_img_edit_w,
                ass_img_edit_b              : ass_img_edit_b,
                ass_img_add_w               : ass_img_add_w,
                ass_img_info_b              : ass_img_info_b,


                enum_moveToOptions          : enum_moveToOptions,
                enum_langCodes              : enum_langCodes,
                enum_banks_n                : enum_banks_n,
                DataHooks_o,

                format_bankNumber_s         : format_bankNumber_s,
                format_cost_s               : format_cost_s,
                format_langCode_fs          : format_langCode_fs,

                helper_getDirectionByLangCode_fe : helper_getDirectionByLangCode_fe,
                helper_getLangFlagWithLangCode_fr : helper_getLangFlagWithLangCode_fr,
                format_date_YYYY_MM_DD_fs : format_date_YYYY_MM_DD_fs,
            }
        },
        computed:{
            co_uds_moreInfo_haveChanges_b(){
                return !obj_equals_fb(this.server_uds_moreInfo_c, this.new_server_uds_moreInfo_c)
            },
            co_uds_creatorPaymentInfo_haveChanges_b(){
                return !obj_equals_fb(this.server_uds_creatorPaymentInfo_c, this.new_server_uds_creatorPaymentInfo_c)
            },
            co_userData_haveChanges_b(){
                return !obj_equals_fb(this.server_currentUserData_c, this.new_server_currentUserData_c)
            },
            co_mainCreditCard_c(){
                return FB_UserDataSub_CreditCard.udscc_ms_getMainCreditCard_c(this.server_uds_creditCards_byId_c)
            },
            co_availableMoreInfoLangCode_ae(){

                let langCode_ae = Object.values(enum_langCodes)
                return langCode_ae.filter(langCode_e => !this.new_server_uds_moreInfo_c.udsmi_langArr_ae.includes(langCode_e))
            },
        },
        methods:{
            m_logout_f(){
                webAppManager_logout_f( () => {
                    route_moveToRoute(enum_moveToOptions.player_profile)
                })
            },
            m_saveCreatorPaymentInfo_f(){
                this.updateBtn_loader_b = true
                serverPre_subUserData_creatorPaymentInfo_update_f(this.new_server_uds_creatorPaymentInfo_c, () => {
                    this.server_uds_creatorPaymentInfo_c = new FB_UserDataSub_CreatorPaymentInfo(obj_deepCopy_f(this.new_server_uds_creatorPaymentInfo_c))
                    this.updateBtn_loader_b = false
                })
            },
            m_saveChanges_f(){

                let callsNum_n = 0
                this.updateBtn_loader_b = true

                if(this.co_uds_moreInfo_haveChanges_b){
                    callsNum_n++

                    this.server_uds_moreInfo_c = new FB_UserDataSub_MoreInfo(obj_deepCopy_f(this.new_server_uds_moreInfo_c))
                    serverPre_subUserData_moreInfo_update_f(this.new_server_uds_moreInfo_c, () => {
                        if(--callsNum_n === 0){this.updateBtn_loader_b = false}
                    })
                }
                if(this.co_userData_haveChanges_b){
                    callsNum_n++

                    serverAuth_currentUserData_update_f(this.new_server_currentUserData_c, (userData_c) => {
                        this.server_currentUserData_c = new FB_UserData(userData_c)
                        this.new_server_currentUserData_c = new FB_UserData(userData_c)

                        if(--callsNum_n === 0){this.updateBtn_loader_b = false}
                    })
                }
            },
            m_avatarPopup_clickTheApproveBtn_f(){
                this.showPopup_avatarGenerator_vb.val=false

                this.getFile_vf.val((file_c) =>{
                    this.new_server_currentUserData_c.ud_avatar_c.cuda_imgFile_c = file_c
                })
            },
            m_routeWithLang_s(langCode_es){
                return route_switchLangCode_es(this.$route, langCode_es)
            },
            m_autoRenew_f(){
                this.server_uds_subscriptionPlanInfo_c.udsspi_autoRenew_b = !this.server_uds_subscriptionPlanInfo_c.udsspi_autoRenew_b
                serverPre_subUserData_subscriptionPlanInfo_update_f(this.server_uds_subscriptionPlanInfo_c, ()=> {
                    console.log("update")
                })
            },
            m_updateSubscriptionPlan_f(uds_newSubscriptionPlanInfo_c){
                console.log(uds_newSubscriptionPlanInfo_c)
                this.showPricingPlans_vb.val = false
                this.server_uds_subscriptionPlanInfo_c = uds_newSubscriptionPlanInfo_c
            }
        },

        // lifeCircle
        mounted(){

            // 1) get user data
            serverAuth_currentUserData_get_vl_fp(this.$options.name, (currentUserData_c) => {

                if(currentUserData_c == null){return}

                this.server_currentUserData_c = currentUserData_c
                this.new_server_currentUserData_c = new FB_UserData(currentUserData_c)

                // get more info
                serverPre_subUserData_moreInfo_get_f({
                    userId_uid : currentUserData_c.ud_userId_uid,
                    cb_f : (uds_moreInfo_c) => {
                        this.server_uds_moreInfo_c = uds_moreInfo_c
                        this.selectedMoreInfoLangCode_e = uds_moreInfo_c.udsmi_langArr_ae[0]
                        this.new_server_uds_moreInfo_c = new FB_UserDataSub_MoreInfo(obj_deepCopy_f(this.server_uds_moreInfo_c))
                    }
                })

                // get subscription play
                serverPre_subUserData_subscriptionPlanInfo_get_f({
                    userId_uid : currentUserData_c.ud_userId_uid,
                    cb_f : (uds_subscriptionPlanInfo_c) => {
                        this.server_uds_subscriptionPlanInfo_c = uds_subscriptionPlanInfo_c
                    }
                })

                // get credit card
                serverPre_subUserData_creditCards_cl_set_f({
                    viewName_s: this.$options.name,
                    userId_uid : currentUserData_c.ud_userId_uid,
                    cb_f : (uds_creditCards_c) => {
                        if(uds_creditCards_c){
                            this.$set(this.server_uds_creditCards_byId_c, uds_creditCards_c.udscc_m_id_s(), uds_creditCards_c)
                        }
                    }
                })

                // get bank info
                serverPre_subUserData_creatorPaymentInfo_get_f({
                    userId_uid : currentUserData_c.ud_userId_uid,
                    cb_f : (uds_creatorPaymentInfo_c) => {

                        this.server_uds_creatorPaymentInfo_c = uds_creatorPaymentInfo_c

                        this.new_server_uds_creatorPaymentInfo_c = new FB_UserDataSub_CreatorPaymentInfo(obj_deepCopy_f(uds_creatorPaymentInfo_c))

                    }
                })

            })

            // listener for iframe Icredit
            eventListener_addEventListenerToObj(window, enum_eventsListenersNames.message, false, this.$options.name, (event) => {
                let msg_s = event.data.msg

                if(msg_s == null){
                    return
                }
                this.addNewCard_o.showPopup_vb.val = false

                if(msg_s === enum_iframeMsg.failed_s) {
                    notification_notify2({
                        title_s: ass_strings.oneWord_notice[this.p_system_langCode_e],
                        text_s: ass_strings.threeWords_somethingWentWrong[this.p_system_langCode_e]})

                }else if(msg_s === enum_iframeMsg.success_s) {
                    notification_notify2({
                        title_s : ass_strings.oneWord_updated[this.store_system_langCode_ve.val],
                        text_s  : ass_strings.fourWords_addedNewCreditCard[this.store_system_langCode_ve.val]
                    })
                }
            })

        },
        destroyed() {

            eventListener_removeEventListenerToObj(window, enum_eventsListenersNames.message, this.$options.name)

            serverAuth_currentUserData_remove_vl_f(this.$options.name)

            serverPre_subUserData_creditCards_cl_remove_f({
                viewName_s: this.$options.name,
                userId_uid : this.server_currentUserData_c.ud_userId_uid
            })
        }
    }
</script>

<style scoped lang="scss">

</style>
